import styled from "styled-components";
import { HexColor } from "../../../../types/styles";

export const StyledError = styled.div`
  > div + div {
    margin-top: 10px;
  }
`;

export const StyledNote = styled.div<{ color: HexColor }>`
  font-size: 12px;
  margin-top: 4px;
  color: ${({ color }) => color};
`;
